import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VariableData } from '../models/other/variable-data';
@Injectable({
  providedIn: 'root'
})
export class VariableMaxLengthService {

  private variablesSubject: BehaviorSubject<Array<VariableData>> = new BehaviorSubject<Array<VariableData>>([]);
  variablesData$ = this.variablesSubject.asObservable();

  /**
   * Add a single variable to the array with maximum lengths for all variables
   * @param variable 
   */
  addSingleVariableMaximumLength(variable: VariableData): void {
    const current = this.variablesSubject.value;
    // make a new array with the extra block
    this.variablesSubject.next([
      ...current,
      variable
    ]);
  }

  constructor() { }
}